/**
 * ERP Audit - Stub
 * Audit trail functions retained as no-ops for CalfHealth brand.
 * Will be replaced with CalfHealth-specific audit in Phase 2.
 */

export function computeShallowDiff(before, after) {
  if (!before && !after) return {};
  if (!before) return { ...after };
  if (!after) return {};
  const diff = {};
  const allKeys = new Set([...Object.keys(before), ...Object.keys(after)]);
  for (const key of allKeys) {
    if (before[key] !== after[key]) {
      diff[key] = { from: before[key], to: after[key] };
    }
  }
  return diff;
}

export async function writeERPAuditEntry(userId, entry) {
  // No-op stub — audit trail disabled for CalfHealth brand
  return;
}
